import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import OrderTipsModalStore from './store';

import $$tracker from '@src/tracker';

const styles = require('./index.less');

/**
 * 预约前置弹窗
 */
const OrderTipsModal = ({ store, onClose, onOrderClick }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.orderTipsModalRoot)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.title} />
        <div className={styles.content} />
        <Link className={styles.btnOrder} href="https://s.xoyo.com/rWydf0" onClick={store.goWechatReservation} />
        <Link
          className={styles.btnPhone}
          onClick={() => {
            $$tracker.clickPopupPhoneReserve();
            onOrderClick && onOrderClick();
          }}
        />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(OrderTipsModal, OrderTipsModalStore);
